export enum AppModalVerticalPositionEnum {
    Top = 'top',
    Middle = 'middle',
    Bottom = 'bottom',
}
